import { Avatar } from 'primereact/avatar'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { setCreateDialogResult } from '../api/create-dialog'
import { IDialogParams } from '../api/types/dialog.interface'
import { getActionLabel } from '../lib/create-dialog/get-action-label'
import { getHeaderIcon } from '../lib/create-dialog/get-header-icon'

export const CreateDialogModal = ({
	show,
	close,
	params,
}: IDialogParams<any>) => {
	const headerElement = (
		<div className='inline-flex align-items-center justify-content-center gap-2'>
			<Avatar icon={getHeaderIcon(params.icon)} shape='circle' />
			<span
				className='font-bold white-space-nowrap'
				style={{ paddingLeft: '1rem' }}
			>
				{params.title}
			</span>
		</div>
	)

	const footerContent = (
		<div>
			{params.buttons.map((btn: any, index: number) => {
				return (
					<Button
						key={index}
						label={getActionLabel(btn)}
						severity={btn !== params.default ? 'secondary' : undefined}
						outlined={btn !== params.default}
						autoFocus
						onClick={async () => {
							const response = await setCreateDialogResult({
								objid: params.objid,
								return: btn,
								data: params.data,
							})

							if (response) {
								close()
							}
						}}
					/>
				)
			})}
		</div>
	)

	return (
		<Dialog
			dismissableMask={false}
			header={headerElement}
			footer={footerContent}
			visible={show}
			style={{ width: '25vw' }}
			onHide={() => close()}
		>
			<div style={{ whiteSpace: 'break-spaces' }}>{params.text}</div>
		</Dialog>
	)
}
